/* loaded by smart-asset */
export default require("./layers-24px~bfqybfrm.svg")